<template>
  <div class="font1">
      <v-container class="" style="border-radius:15px;color:black;background-color:#fffcfc">
      <p class="text-h4 text-center mt-4 animate__animated animate__fadeIn animate_slow" style="color:#052542">HouseHold Information</p>
      <Stepper />
      

     
    
    <!-- SUbmit or cancel -->
    <div>
        
    </div>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios'
import Stepper from '../components/Stepper.vue'
export default {
components: {
    Stepper
  },
  data(){
    return {
      row:""
    }
  },
  methods:{
    submitreq(){
      axios.post('https://housing-match-server.herokuapp.com/state2',{
        statcode:"GA"
      }).then(res=>{
        console.log(res.data)
        console.log(typeof res.data)
        this.$store.commit("setData",res.data)
        this.$router.push("/c/affordable-housing-locator")
        
      }).catch(err=>{
        console.log(err)
      })
    }
  }
}
</script>

<style>
.font1{
    font-family: 'Ubuntu', sans-serif;
}
</style>